import { useEffect, useState, useRef } from "react"
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import authAxios from "../../components/authAxios";
import DashboardHeader from "../../components/DashboardHeader";

import { IconButton } from "@mui/material";
import DescriptionIcon from '@mui/icons-material/Description';
import Tooltip from '@mui/material/Tooltip';


//TABS - BOOTSTRAP
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';

//TABS - ANT DESIGN
// import { Tabs } from "antd";

import TransactionList from "../accounting/TransactionList";
import ApplicationView from "./ApplicationView";
import CustomerView from "../crm/CustomerView";
import ApplicantFinancialsView from "./ApplicantFinancialsView";

import UserAlerts from "../../components/UserAlerts";


const Application = () => {
    const params = useParams()
    const navigate = useNavigate()
    const [error, setError] = useState('');
    const errorRef = useRef(null);

    const applicationId = params.id


    const [removeBorder, setRemoveBorder] = useState(true);
    const [page, setPage] = useState(1);
    const [pagecount, setPageCount] = useState();

    const [customerId, setCustomerId] = useState(null);

    // const { data: clientProfile } = useQuery({
    //     queryKey: ['clientProfile'],
    //     queryFn: async () => {
    //       const response = await authAxios.get(`/clientprofiles/${localStorage.getItem('clientProfile')}`);
    //       return response.data

    //     },
    // });

    // const { data: transactions } = useQuery({
    //     queryKey: ['customer-statement', page],
    //     queryFn: async () => {
    //       const response = await authAxios.get(`/accounting/customer-ledger/?customer=${params.id}&page=${page}`);
    //       setPageCount(response.data.page_count)
    //       return response.data.results
    //     },
    // });

    const { data: customer } = useQuery({
        queryKey: ['customer', applicationId],
        queryFn: async () => {
          const response = await authAxios.get(`crm/customers/${customerId}`);
          return response.data
        },
        enabled: !!customerId,
    });


    const { data: application } = useQuery({
        queryKey: ['application', applicationId],
        queryFn: async () => {
          const response = await authAxios.get(`loans/loan-applications/${applicationId}`);
          setCustomerId(response.data.customer)
          return response.data
        },
    });




    //CALC STATS
    // let sumInvoices = 0
    // let sumReceipts = 0
    // let balance = 0

    //Bootstrap Tabs
    const [key, setKey] = useState('applicant');
    const handleTabChange = (k) => {
        setKey(k)
    };

    // PAGINATION
    const handlePageChange = (event, value) => {
        setPage(value);
    };

    useEffect(()=>{
        if (error){
            errorRef.current.scrollIntoView();  
        }            
    },[error])

    return (
        <div className="dashboard-main">
            {application &&

            <section className="dashboard-content dashboard-content-compact">
                 <div ref={errorRef}>
                    <UserAlerts error={error} />
                </div>

                <div className="dashboard-content-header-nav">
                    <DashboardHeader dashboardTitle={application.customer_name} dashboardPreTitle="Loan Application" removeBorder={removeBorder} />
                    <div className="dashboard-content-header-nav-icons">
                        <Tooltip title="Statement">
                            <IconButton 
                                onClick={() => navigate('/dashboard/statement/',{state:{reference:params.id}})}
                            > 
                                <DescriptionIcon/>
                            </IconButton>
                        </Tooltip>
                    </div>
                </div>


              
                <Tabs
                    activeKey={key}
                    onSelect={(k) => handleTabChange(k)}
                    className="dashboard-tabs"
                    id="customer-tabs"
                    mountOnEnter={true}
                    unmountOnExit={true}
                    transition={false}
                    >
                    
                    <Tab eventKey="applicant" title="Applicant">
                        <CustomerView
                            customer={customer}
                            variant="applicant"
                            setError={setError}
                        />
                    </Tab>

                    <Tab eventKey="loan-details" title="Loan Details">
                        <ApplicationView
                            application={application}
                            setError={setError}
                        />
                    </Tab>
                    
                    <Tab eventKey="financials" title="Financials">
                        <ApplicantFinancialsView
                            application={application}
                            setError={setError}
                        />
                    </Tab>

                    <Tab disabled eventKey="guarantors" title="Guarantors">
                    </Tab>

                    <Tab disabled eventKey="security" title="Security">
                    </Tab>

                    {/* <Tab eventKey="statement" title="Ledger">
                        {clientProfile &&
                        <div className="dashboard-content-subheader">
                            <div className='dashboard-card'>
                                <div className="dashboard-card-pretitle">
                                    Debits
                                </div>
                                <div className="dashboard-card-text">
                                    {clientProfile.currency_code} {Number(customer.total_debits).toLocaleString()}
                                </div>
                            </div>
                            <div className='dashboard-card'>
                                <div className="dashboard-card-pretitle">
                                    Credits
                                </div>
                                <div className="dashboard-card-text">
                                    {clientProfile.currency_code} {Number(customer.total_credits).toLocaleString()}
                                </div>
                            </div>
                            <div className='dashboard-card'>
                                <div className="dashboard-card-pretitle">
                                    Balance
                                </div>
                                <div className="dashboard-card-text">
                                    {clientProfile.currency_code} {customer.balance.toLocaleString()}
                                </div>
                            </div>

                        </div>
                        }
                        <TransactionList 
                            module="CRM" 
                            transactions={transactions} 
                            handlePageChange={handlePageChange} 
                            page={page} 
                            pagecount={pagecount}
                        />
                    </Tab> */}
                </Tabs> 
            </section>
            }
        </div>
    );
  };
  
  export default Application;